import * as actions from '../actions/types'

const initialState = {
  firstName: '',
  lastName: ''
};

function updateBasicInfo(basicState, action){
  return {
    ...basicState,
    ...action.updates
  };
}

function setBasicInfo(basicState, action){
  return {
    ...action.application.basic
  };
}

function applicationDeleted() {
  return initialState;
}

export const basicInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPDATE_BASIC_INFO: return updateBasicInfo(state, action);
    case actions.SET_APPLICATION:
    case actions.REFRESH_APPLICATION:
      return setBasicInfo(state, action);
    case actions.DELETE_APPLICATION_SUCCESS: return applicationDeleted(state, action);
    default: return state;
  }
};

export default basicInfoReducer;